import { render, staticRenderFns } from "./ClientCompanies.vue?vue&type=template&id=55bc9a78&scoped=true"
import script from "./ClientCompanies.vue?vue&type=script&lang=js"
export * from "./ClientCompanies.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55bc9a78",
  null
  
)

export default component.exports